import { fmtDate } from "@/lib/format";
import { cn } from "@/lib/utils";
import { SectionShell } from "./SectionShell";

const dot = (kind) => ({
  done: "bg-primary ring-primary/25",
  deadline: "bg-card ring-amber-400 border-2 border-amber-400",
  planned: "bg-card ring-border border-2 border-foreground/40",
  range: "bg-card ring-border border-2 border-primary",
}[kind] || "bg-card ring-border border-2 border-foreground/40");

/** 02 · Leveranse og tidslinje. Only milestones the data actually supports – the labels say "planlagt"/"ønsket" where relevant. */
export const ProposalTimeline = ({ data }) => {
  const items = data.timeline || [];
  if (!items.length) return null;
  return (
    <SectionShell id="leveranse" no="02" title="Leveranse og tidslinje" lede="Planlagte milepæler fra tilbud til retur. Endelige datoer avtales ved bestilling.">
      <div className="relative ml-2 sm:ml-0" data-testid="proposal-timeline">
        <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-border/80 sm:block" aria-hidden="true" />
        <ol className={cn("grid gap-8 border-l border-border/80 sm:gap-6 sm:border-l-0", items.length >= 5 ? "sm:grid-cols-3 lg:grid-cols-6" : "sm:grid-cols-2 lg:grid-cols-4")}>
          {items.map((t) => (
            <li key={t.key} className="relative pl-6 sm:pl-0" data-testid={`proposal-timeline-${t.key}`}>
              <span className={cn("absolute -left-[7.5px] top-1 h-[14px] w-[14px] rounded-full ring-4 ring-background sm:static sm:block", dot(t.kind))} aria-hidden="true" />
              <div className="sm:mt-4">
                <div className="font-mono text-[12.5px] tabular text-muted-foreground">
                  {t.kind === "range" ? `${fmtDate(t.start)} – ${fmtDate(t.end)}` : t.date ? fmtDate(t.date) : "Avtales"}
                </div>
                <div className="mt-1 text-[15px] font-medium leading-snug">{t.label}</div>
                {t.text && <p className="mt-1 text-[13px] leading-5 text-muted-foreground">{t.text}</p>}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </SectionShell>
  );
};
